import { render, staticRenderFns } from "./ErrorSeverityFormModal.vue?vue&type=template&id=36aaa816"
import script from "./ErrorSeverityFormModal.vue?vue&type=script&lang=js"
export * from "./ErrorSeverityFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports